module.exports = __webpack_public_path__ + "media/images/buttercms/logo-9872718e39a5866d2f7fed6fa11c63e5.png";